import { useRecordContext } from "react-admin"

const UserTitle = () => {
  const record = useRecordContext()

  return <span>{record ? `"${record.display_name}"` : ""} [User]</span>
}

export { UserTitle }
